import React from "react";
import Icon1 from "../../assets/icons/iq1-w.png";
import Icon2 from "../../assets/icons/iq2-w.png";
import Icon3 from "../../assets/icons/iq3-w.png";
import "./IQPlatform.scss";
import ImageSideIQComponent from "../../components/ImageSideIQComponent/ImageSideIQComponent";
import logo from "../../assets/ab1-large-icon.png";
import IQframe from "../../assets/iphone-frame.png";
import AB1_Investor_Slide from "../../assets/AB1_investor_slider_img.png";
import AB1_Investor_Slide_Mobile from "../../assets/investor-slide-mob-view.png";
import aircraft_img from "../../assets/aircraft-img-w.png";
import checkmark_img from "../../assets/check.png";
const IQPlatform = () => {
  let statements = [
    {
      icon: Icon3,
      statement: "Proprietary </br> Algorithms",
    },
    {
      icon: Icon1,
      statement: "Real-time, Highly </br> Accurate Quoting Engine",
    },
    {
      icon: Icon2,
      statement: "CRM integration <br/> ready",
    },
  ];

  return (
    <div className="iq-main iq">
      <div className="bg-img">
        <div className="iq-demo">
          <div className="iq-root-mission">
            <div className="iq-logo-wrapper">
              <img className="icon logo-width" src={logo} alt="Logo" />
            </div>
            <div className="iq-mission-wrapper">
              <h1 className="iq-mission">
                Revolutionizing Private Aviation Technology
              </h1>
            </div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "500",
                color: "#535353",
                display: "flex",
                textAlign: "left",
                paddingTop: "25px",
              }}
            >
              AIRBOOK ONE&rsquo;S new proprietary Black Label solution, the
              &lsquo;IQ Platform&rsquo;,
              <br /> Simplifies Any Operators Life
            </div>
            <ul className="iq-checklist">
              <li>
                <img src={checkmark_img} alt="checkmark" /> Proprietary
                Quotability Platform
              </li>
              <li>
                <img src={checkmark_img} alt="checkmark" /> Full Fleet Quoting
                In Seconds
              </li>
              <li>
                <img src={checkmark_img} alt="checkmark" /> Predicts Most
                Efficient Routing
              </li>
            </ul>
            <div className="iq-setup-mission" style={{ display: "flex" }}>
              <a href="https://meetings.hubspot.com/sales-ab1" target="_blank">
                <button className="iq-setup-demo">Setup Demo</button>
              </a>
            </div>
          </div>

          <div className="iq-mockup-wrapper">
            <img src={IQframe} alt="Mobile Mockup" className="iq-mockup" />
          </div>
        </div>
      </div>

      <div className="investor-slide-wrapper">
        <div className="how-we-build">
          <div className="top-fade-overlay"></div>
          <img
            className="icon AB1-Investor-Slide"
            src={AB1_Investor_Slide}
            alt=""
          />
        </div>
        <div className="how-we-build-mobile" style={{ display: "none" }}>
          <h3>
            How We <br /> Are Built
          </h3>
          <img
            className="icon AB1-Investor-Slide"
            src={AB1_Investor_Slide_Mobile}
            alt=""
          />
        </div>
      </div>
      <div className="iq-root">
        <div className="iq-title">
          Our new Black Label product for operators is a highly customized
          solution that saves both time and money for any charter operator.
        </div>
        <img className="icon" src={aircraft_img} alt="" />
      </div>

      <div className="iq-container">
        <div className="iq-statements">
          {statements.map((statement, i) => {
            return (
              <div key={i} className="Statement">
                <img className="icon" src={statement.icon} alt="" />
                <h4
                  className="text"
                  dangerouslySetInnerHTML={{ __html: statement.statement }}
                ></h4>
              </div>
            );
          })}
        </div>
      </div>

      <div className="iq-frames">
        <ImageSideIQComponent />
      </div>
      <div className="iq-demo-wrapper">
        <div className="iq-demo-container">
          <h1 className="iq-mission iq-dem-btm dem-btn-align iq-mission-text">
            AIRBOOK ONE&rsquo;S new proprietary Black Label solution, the
            &lsquo;IQ Platform&rsquo;, Simplifies Any Operators Life
          </h1>

          <div className="iq-setup-mission">
            <a href="https://meetings.hubspot.com/sales-ab1" target="_blank">
              <button className="iq-setup-demo">Setup a Demo</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IQPlatform;
